import React, { useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { ProjectsPage } from './pages/ProjectsPage';
type Page = 'landing' | 'projects';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('landing');
  return <>
      {currentPage === 'landing' ? <LandingPage onNavigate={setCurrentPage} data-id="element-0" /> : <ProjectsPage onNavigate={setCurrentPage} data-id="element-1" />}
    </>;
}